var dlLanguage = {};

function getLanguage() {
  var mercado = 'es';
  var idioma = 'es';
  var segments = new URL(window.location.href).pathname.split('/');

  if (segments.length >= 2) {
    var parts = segments[1].split('-');
    if (parts.length >= 2) {
      idioma = parts[0].toLowerCase();
      mercado = parts[1].toLowerCase();
    }
  }

  dlLanguage = { mercado: mercado, idioma: idioma };
  return dlLanguage;
}

function isoDateToFormated(isoDate) {
  return isoDate.substring(0, 10);
}

function fdSetCartTokenCookie(cartToken) {
  localStorage.setItem('fd_cart_token', cartToken);
}

function fdGetCartTokenFromCookie() {
  var token = localStorage.getItem('fd_cart_token');
  return token ? token : '';
}

function fdRemoveCartTokenCookie() {
  localStorage.removeItem('fd_cart_token');
}

function fdSetCartUpdatedCookie() {
  localStorage.setItem('fd_cart_update', Date.now());
}

function fdGetCartUpdatedFromCookie() {
  var updated = localStorage.getItem('fd_cart_update');
  return updated ? isoDateToFormated(new Date(parseInt(updated)).toISOString()) : '';
}

function fdRemoveCartUpdatedCookie() {
  localStorage.removeItem('fd_cart_update');
}

function fdSetCartCreatedCookie() {
  localStorage.setItem('fd_cart_create', Date.now());
}

function fdGetCartCreatedFromCookie() {
  var created = localStorage.getItem('fd_cart_create');
  return created ? isoDateToFormated(new Date(parseInt(created)).toISOString()) : '';
}

function fdRemoveCartCreatedCookie() {
  localStorage.removeItem('fd_cart_create');
}

function fdSetProductsCartCookie(items) {
  localStorage.setItem('fd_current_cart_products', JSON.stringify(items));
}

function fdGetProductsCartCookie() {
  var products = localStorage.getItem('fd_current_cart_products');
  return products ? JSON.parse(products) : [];
}

function fdRemoveAllFromCartCookie() {
  localStorage.removeItem('fd_current_cart_products');
  fdRemoveCartUpdatedCookie();
  fdRemoveCartCreatedCookie();
  fdRemoveCartTokenCookie();
}

function fdSetUserIdCookie(userData) {
  localStorage.setItem('fd_userid', userData);
}

function fillCartData(data, cart) {
  if (cart.item_count > 0) {
    var updated = fdGetCartUpdatedFromCookie();
    data.date_update__cart = updated ? updated : '';
    var created = fdGetCartCreatedFromCookie();
    data.date_created__cart = created ? created : '';
    data.total_quantity_cart = cart.item_count > 0 ? cart.item_count : '';
    data.total_price_cart = cart.total_price > 0 ? cart.total_price / 100 : '';
  } else {
    data.cart_id = '';
    data.date_update__cart = '';
    data.date_created__cart = '';
    data.total_quantity_cart = '';
    data.total_price_cart = '';
    fdRemoveCartTokenCookie();
    fdRemoveCartCreatedCookie();
    fdRemoveCartUpdatedCookie();
  }
  return data;
}

function getCollectionsFormated(item) {
  var itemCategory = [{ title: '' }, { title: '' }, { title: '' }, { title: '' }, { title: '' }, { title: '' }];

  if (item.type && item.type !== '') {
    var pieces = item.type.split(' > ');
    itemCategory[0].title = pieces.join('|');
    for (var i = 0; i < pieces.length; i++) {
      itemCategory[i + 1].title = pieces[i];
    }
  }

  return itemCategory;
}

function transformForProductDataLayer(params, variantId) {
  var product = params.product;
  var cart = params.cart;
  variantId = variantId || '';

  var productDiscount = 0;
  var priceWithoutDiscount = product.price / 100;
  var discountPercentage = 0;

  if (product.compare_at_price) {
    productDiscount = (product.compare_at_price - product.price) / 100;
    priceWithoutDiscount = product.compare_at_price / 100;
    discountPercentage = Math.round((productDiscount * 100) / priceWithoutDiscount);
  }

  var itemCategory = getCollectionsFormated(product);
  var cartId = cart.token ? cart.token : '';
  var cartUpdated = fdGetCartUpdatedFromCookie();
  var cartCreated = fdGetCartCreatedFromCookie();
  var language = getLanguage();

  var selectedVariantId = new URLSearchParams(window.location.search).get('variant');
  var selectedVariant = product.variants[0];

  if (selectedVariantId && selectedVariantId !== '') {
    var found = product.variants.find(function (item) {
      return item.id == Number(selectedVariantId);
    });
    if (found) selectedVariant = found;
  }

  var productDataLayer = {
    cart_id: cartId,
    date_created__cart: cartCreated ? cartCreated : '',
    date_update__cart: cartUpdated ? cartUpdated : '',
    total_quantity_cart: cart.item_count > 0 ? cart.item_count : '',
    total_price_cart: cart.total_price > 0 ? cart.total_price / 100 : '',
    items: [
      {
        item_name: product.title,
        item_id: selectedVariant.id,
        ean: selectedVariant.barcode,
        id_reference: variantId ? variantId : product.variants[0].id,
        price: product.price / 100,
        price_without_discount: priceWithoutDiscount.toFixed(2),
        discount: productDiscount.toFixed(2),
        discount_percentage: discountPercentage,
        item_brand: product.vendor,
        item_category: itemCategory[0].title,
        item_variant: selectedVariant.name,
        is_in_stock: product.variants[0].available ? 'yes' : 'no',
        image: 'https:' + product.featured_image,
        url: '/products/' + product.handle,
        quantity: product.quantity === undefined ? 1 : product.quantity,
        currency: cart.currency,
        is_on_sale: productDiscount > 0 ? 'yes' : 'no',
        added_date: product.created_at.substring(0, 10),
        mercado: language.mercado,
        idioma: language.idioma,
        size: undefined,
      },
    ],
  };

  if (!product.item_list_name || product.item_list_name === '') {
    product.item_list_name = '';
  }

  for (var i = 0; i < product.variants.length; i++) {
    if (product.variants[i].id === variantId) {
      productDataLayer.items[0].size = product.variants[i].title;
    }
  }

  productDataLayer.item_list_name = product.item_list_name;
  return fillCartData(productDataLayer, cart);
}

function fdGtag(event, data) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({ event: event, ecommerce: data });
}

function fdFetchJson(path) {
  return fetch(window.Shopify.routes.root + path, { credentials: 'same-origin' }).then(function (response) {
    if (!response.ok) throw new Error('Error fetching ' + path);
    return response.json();
  });
}

function manageProductAddToCart(productHandle, productQuantity, variantId, listName) {
  productQuantity = productQuantity === undefined ? 1 : productQuantity;
  listName = listName || '';

  fdSetCartUpdatedCookie();
  if (fdGetCartCreatedFromCookie() === '') {
    fdSetCartCreatedCookie();
  }

  return Promise.all([fdFetchJson('products/' + productHandle + '.js'), fdFetchJson('cart.js')])
    .then(function (results) {
      var dataToSend = { product: results[0], cart: results[1] };
      dataToSend.product.quantity = parseInt(productQuantity);
      dataToSend.product.item_list_name = listName;

      if (fdGetCartTokenFromCookie() === '') {
        fdSetCartTokenCookie(dataToSend.cart.token);
      }

      var productDataLayer = transformForProductDataLayer(dataToSend, variantId);
      fdGtag('add_to_cart', productDataLayer);

      var cartCookieData = fdGetProductsCartCookie();
      if (cartCookieData.length === 0) {
        fdSetProductsCartCookie(productDataLayer.items);
      } else {
        productDataLayer.items.forEach(function (item) {
          var index = cartCookieData.findIndex(function (cookieItem) {
            return cookieItem.item_id === item.item_id;
          });
          if (index !== -1) {
            cartCookieData[index].quantity = parseInt(cartCookieData[index].quantity);
          } else {
            cartCookieData.push(item);
          }
        });
        fdSetProductsCartCookie(cartCookieData);
      }
    })
    .catch(function (error) {
      console.error(error);
    });
}

function manageProductRemoveFromCart(productHandle, productQuantity, variantId, listName) {
  productQuantity = productQuantity === undefined ? 1 : productQuantity;
  listName = listName || '';

  fdSetCartUpdatedCookie();

  return Promise.all([fdFetchJson('products/' + productHandle + '.js'), fdFetchJson('cart.js')])
    .then(function (results) {
      var dataToSend = { product: results[0], cart: results[1] };
      dataToSend.product.quantity = parseInt(productQuantity);
      dataToSend.product.item_list_name = listName;

      var productDataLayer = transformForProductDataLayer(dataToSend, variantId);
      fdGtag('remove_from_cart', productDataLayer);

      var cartCookieData = fdGetProductsCartCookie();
      if (cartCookieData.length > 0) {
        productDataLayer.items.forEach(function (item) {
          var index = cartCookieData.findIndex(function (cookieItem) {
            return cookieItem.item_id === item.item_id;
          });
          if (index !== -1) {
            cartCookieData.splice(index, 1);
          }
        });
        fdSetProductsCartCookie(cartCookieData);
      }
    })
    .catch(function (error) {
      console.error(error);
    });
}

function fdTrackViewItem(dataForTransform) {
  var send = function () {
    fdGtag('view_item', transformForProductDataLayer(dataForTransform));
  };

  if (dataForTransform.cart.token) {
    send();
    return;
  }

  fdFetchJson('cart.js')
    .then(function (cart) {
      if (cart.item_count > 0) {
        fdSetCartTokenCookie(cart.token);
        dataForTransform.cart.token = cart.token;
      }
      send();
    })
    .catch(function (error) {
      console.error('Error loading cart.js:', error);
    });
}

function fdItemHandle(item) {
  if (item.handle) return item.handle;
  if (!item.url) return '';
  return item.url.split('?')[0].split('/products/').pop();
}

function fdHandleCartResponse(action, data) {
  if (!data) return;

  if (action === 'add') {
    var added = Array.isArray(data.items) ? data.items : data.variant_id ? [data] : [];
    added.forEach(function (item) {
      var handle = fdItemHandle(item);

      if (handle) {
        manageProductAddToCart(handle, item.quantity, item.variant_id, '');
        return;
      }

      fdFetchJson('cart.js')
        .then(function (cart) {
          var line = cart.items.find(function (cartItem) {
            return cartItem.variant_id === item.variant_id;
          });
          if (line) manageProductAddToCart(fdItemHandle(line), item.quantity, item.variant_id, '');
        })
        .catch(function (error) {
          console.error(error);
        });
    });
    return;
  }

  if (data.items_added && data.items_added.length > 0) {
    (data.items || []).forEach(function (item) {
      if (item.title == data.items_added[0].title) {
        manageProductAddToCart(fdItemHandle(item), data.items_added[0].quantity, data.items_added[0].variant_id, '');
      }
    });
  } else if (data.items_removed && data.items_removed.length > 0) {
    manageProductRemoveFromCart(
      fdItemHandle(data.items_removed[0]),
      data.items_removed[0].quantity,
      data.items_removed[0].variant_id,
      ''
    );
  }
}

(function () {
  if (window.fdCartFetchHooked) return;
  window.fdCartFetchHooked = true;

  var originalFetch = window.fetch;

  window.fetch = function () {
    var response = originalFetch.apply(this, arguments);

    try {
      var input = arguments[0];
      var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
      var match = /\/cart\/(add|change|update)(\.js)?$/.exec(new URL(url, window.location.origin).pathname);

      if (match) {
        response
          .then(function (result) {
            if (!result.ok) return;
            return result
              .clone()
              .json()
              .then(function (data) {
                fdHandleCartResponse(match[1], data);
              });
          })
          .catch(function () {});
      }
    } catch (error) {}

    return response;
  };
})();
